module.exports = __webpack_public_path__ + "img/mouth_female_thin.81141781.png";